"use strict";

module.exports = {
  'name': 'eval',
  'category': 'Expression',
  'syntax': ['eval(expression)', 'eval([expr1, expr2, expr3, ...])'],
  'description': 'Evaluate an expression or an array with expressions.',
  'examples': ['eval("2 + 3")', 'eval("sqrt(" + 4 + ")")'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/expression/eval.js
// module id = 875
// module chunks = 0